<template>
  <button><slot></slot></button>
</template>
